export { default } from './centersInfo';
